const fr = {
  "hotel.folio.guest": "Clients",
  "hotel.folio.guest.name": "Nom",
  "hotel.folio.guest.birthday": "Date de naissance",
  "hotel.folio.guest.id_number": "Numéro d’identification",
  "hotel.folio.guest.sex": "Sexe",
  "hotel.folio.guest.nationality": "Nationalité",
  "hotel.folio.guest.target_country": "Pays de destination",
  "hotel.folio.guest.email": "E-mail",
  "hotel.folio.guest.Nombres": "Nom complet",
  "hotel.folio.guest.typeDocument": "Type de document",
  "hotel.folio.guest.type_accomodation": "Type d’hébergement",
  "hotel.folio.guest.room": "Chambre",
  "hotel.folio.guest.phone": "Téléphone",
  "hotel.folio.guest.arrival_date": "Date d’arrivée",
  "hotel.folio.guest.departure_date": "Date de départ",
  "hotel.folio.guest.nights_quantity": "Nombre de nuits",
  "hotel.folio.guest.unit_price": "Tarif / Prix unitaire",
  "hotel.folio.guest.payment_status": "Statut du paiement",
  "hotel.folio.guest.channel": "Canal de réservation",
  "hotel.folio.guest.reason": "Motif du voyage",
  "hotel.folio.guest.Tipo de Ocupante": "Type d’occupant",
  "hotel.folio.guest.company": "Entreprise",
  "hotel.folio.guest.Identificación Empresa": "Identifiant de l’entreprise",
  "hotel.folio.guest.vehicle_plate": "Plaque d’immatriculation",
  "hotel.folio.guest.adult": "Adulte",
  "hotel.folio.guest.child": "Enfant",
  male: "Homme",
  female: "Femme",
  "hotel.folio.guest.main_guest": "Client principal",
  "hotel.folio.guest.type_guest": "Type de client",
  "hotel.folio.guest.type_document": "Type de document",
  "hotel.folio.guest.mobile": "Téléphone portable",
  "hotel.folio.guest.address": "Adresse",
  "hotel.folio.guest.origin_country": "Pays d’origine",
  "hotel.folio.guest.notes": "Notes",
  "hotel.folio.guest.registro_civil": "Acte de naissance",
  "hotel.folio.guest.tarjeta_identidad": "Carte d’identité",
  "hotel.folio.guest.cedula_ciudadania": "Carte de citoyenneté",
  "hotel.folio.guest.tarjeta_extranjeria": "Carte d’identité d’étranger",
  "hotel.folio.guest.cedula_extranjeria": "Carte de citoyenneté étrangère",
  "hotel.folio.guest.nit": "Numéro d’identification fiscale (NIT)",
  "hotel.folio.guest.add_guest": "Ajouter",
  "hotel.folio.guest.cancel": "Annuler",
  "hotel.folio.guest.pasaporte": "Passeport",
  "hotel.folio.guest.tipo_documento_extranjero": "Type de document étranger",
  "hotel.folio.guest.pep": "PEP",
  "hotel.folio.guest.nit_otro_pais": "Numéro fiscal étranger (NIT)",
  "hotel.folio.guest.nuip": "NUIP",
  "hotel.folio.guest.country": "Pays",
  "hotel.folio.guest.subdivision": "Subdivision",
  "hotel.booking.link_web_checkin": "Lien de check-in",
  "hotel.folio.guest.city_co": "Ville",
  "hotel.folio.guest.foreign_city": "Ville étrangère",
  "hotel.folio.guest.welcome_tra":
    "Signons la fiche de police / carte d’enregistrement d’hébergement (FHE)",
  "hotel.folio.guest.hello": "Bonjour",
  hotel_tra_register_card: "Carte d’enregistrement d’hébergement (FHE)",
  "msg-introduction":
    "Nous allons signer la carte d’enregistrement d’hébergement (FHE).",
  "hotel.folio.guest.title-modal-select-lan": "Sélectionner la langue",
  "hotel.folio.guest.btn_finish": "TERMINER",

  "hotel.folio.guest.content_guest": "Clients",
  "hotel.folio.guest.content_info_folio": "Informations du client principal",
  "hotel.folio.guest.content_contract": "Contrat d’hébergement",
  "hotel.folio.guest.content_signature": "Signature numérique",
  "hotel.folio.guest.terms_and_conditions1":
    "J’ai lu et j’accepte les conditions générales du contrat d’hébergement",
  "hotel.folio.guest.terms_and_conditions2":
    " ainsi que la politique de traitement des données personnelles de l’établissement",
  "hotel.folio.guest.guests_no_found": "Aucun client trouvé",
  "hotel.folio.guest.accept_contract":
    "Vous devez accepter le contrat d’hébergement",
  "hotel.folio.signature.updated": "Signature mise à jour avec succès",
  "hotel.folio.guest.finish": "Bienvenue à l’hôtel !",
  "hotel.folio.guest.finish_tra":
    "Merci de vous être enregistré de manière digitale !",
  "hotel.folio.guest.finish_description":
    "Grâce à ce petit geste, vous avez contribué à réduire l’utilisation du papier et à protéger la planète. Chaque action compte.",
  "app.webcheckin.melhos.use_app":
    "Vous pouvez utiliser notre application ! Le plus cool, c’est qu’il n’y a rien à télécharger 😎",
};
export default fr;
